import { render, staticRenderFns } from "./LVehicleViewer.vue?vue&type=template&id=22c45710&scoped=true"
import script from "./LVehicleViewer.vue?vue&type=script&lang=js"
export * from "./LVehicleViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c45710",
  null
  
)

export default component.exports